import { render } from "./patentNav.vue?vue&type=template&id=5d8bafa5&scoped=true"
import script from "./patentNav.vue?vue&type=script&lang=js"
export * from "./patentNav.vue?vue&type=script&lang=js"

import "./patentNav.vue?vue&type=style&index=0&id=5d8bafa5&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8bafa5"]])

export default __exports__